const jobsCalendar = {
  view: 'Sicht',
  calendarView: {
    monthly: 'Monatlich',
    weekly: 'Wöchentlich',
  },

  modalRemoveConfirm: {
    header: 'Warnung!',
    bodySingle: 'Möchten Sie diese Buchung wirklich löschen?',
    bodyMultiple: 'Möchten Sie diese Buchungen wirklich löschen?',
    confirmBtn: 'Löschen',
  },

  calendarTable: {
    actions: {
      delete: 'Löschen'
    },
    cells: {
      dayOff: 'Freier Tag',
    },
    headers: {
      name: 'Name',
      monday: 'Montag {{day}}',
      tuesday: 'Dienstag {{day}}',
      wednesday: 'Mittwoch {{day}}',
      thursday: 'Donnerstag {{day}}',
      friday: 'Freitag {{day}}',
      saturday: 'Samstag {{day}}',
      sunday: 'Sonntag {{day}}',
    },
  },

  filters: {
    profiles: 'Profil',
    students: 'Schüler',
    caregivers: 'Pflegekräfte',
    employees: 'Mitarbeiter',
    passengers: 'Fahrgäste',
  }, 

  shiftsFilter:{
    all:'Alle Fahrgäste',
    withShift: 'Fahrgäste mit Schichten',
    withoutShifts: 'Fahrgäste ohne Schichten',
  },
};

export default jobsCalendar;